import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  ref: "prMisMatchAddress",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  "aria-labelledby": "staticBackdropLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Public Records Address Mismatch")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, "No exact match was found for that address. See the closest match below.", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "font-weight-bold" }, "You entered:", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "font-weight-bold" }, "Our closest match is:", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, "Choose \"Use Closest Match\" if the suggested address is correct, or choose \"Continue\" if you wish to proceed without Public Records.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalHeader = _resolveComponent("ModalHeader")!
  const _component_ModalBody = _resolveComponent("ModalBody")!
  const _component_ModalFooter = _resolveComponent("ModalFooter")!
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ModalHeader, { showToolBarClose: false }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_ModalBody, null, {
          default: _withCtx(() => [
            _hoisted_5,
            _hoisted_6,
            _createElementVNode("div", null, _toDisplayString(this.misMatchAddress.compAddress.address1), 1),
            _createElementVNode("div", null, _toDisplayString(this.misMatchAddress.compAddress.unitNumber) + " " + _toDisplayString(this.misMatchAddress.compAddress.city) + ", " + _toDisplayString(this.misMatchAddress.compAddress.state) + ", " + _toDisplayString(this.misMatchAddress.compAddress.zipCode), 1),
            _hoisted_7,
            _hoisted_8,
            _createElementVNode("div", null, _toDisplayString(this.misMatchAddress.closestAddress.address1), 1),
            _createElementVNode("div", null, _toDisplayString(this.misMatchAddress.closestAddress.unitNumber) + " " + _toDisplayString(this.misMatchAddress.closestAddress.city) + ", " + _toDisplayString(this.misMatchAddress.closestAddress.state) + ", " + _toDisplayString(this.misMatchAddress.closestAddress.zipCode), 1),
            _hoisted_9
          ]),
          _: 1
        }),
        _createVNode(_component_ModalFooter, null, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.useClosestMatch()))
            }, "Use Closest Match"),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.prContinue()), ["stop"]))
            }, "Continue")
          ]),
          _: 1
        }),
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_Loader, {
              key: 0,
              showLBackDrop: true
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ], 512))
}